// Site chrome & marketing (non–game flow) transition messages

import type { TransitionMessages } from '../../types';

export const SITE: Record<string, TransitionMessages> = {
  loadingProducts: {
    top: {
      'en-US': 'Loading products',
      'en-GB': 'Loading products',
      'en-AU': 'Loading products',
      'en-IN': 'Loading products',
      'es-ES': 'Cargando productos',
      'es-US': 'Cargando productos',
    },
  },
};
